<template>
  <aside
    class="animate-pulse block bg-gray-200"
    :class="{
      'rounded-md': rounded,
      'max-w-full': maxWidth,
      'max-h-full': maxHeight,
    }"
  ></aside>
</template>

<script>
export default {
  props: {
    rounded: { type: Boolean, default: true },
    maxWidth: { type: Boolean, default: true },
    maxHeight: { type: Boolean, default: true },
  },
}
</script>
